import { render, staticRenderFns } from "./NameArray.vue?vue&type=template&id=23b4e78e&scoped=true&"
import script from "./NameArray.vue?vue&type=script&lang=js&"
export * from "./NameArray.vue?vue&type=script&lang=js&"
import style0 from "./NameArray.vue?vue&type=style&index=0&id=23b4e78e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b4e78e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\web\\V-LAB\\project\\bayes-vue2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23b4e78e')) {
      api.createRecord('23b4e78e', component.options)
    } else {
      api.reload('23b4e78e', component.options)
    }
    module.hot.accept("./NameArray.vue?vue&type=template&id=23b4e78e&scoped=true&", function () {
      api.rerender('23b4e78e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NameArray.vue"
export default component.exports